module.exports = __webpack_public_path__ + "static/media/carpooling5.7f2fdb53.PNG";